import { httpClient } from '@bcba/client-auth';
import { baseCropPledgePath } from '..';
import { CommonSetCropPledgeCreditorDto } from '../dto/update';

export const patchCropPledgeCreditorInformationSetCreditor = async (
  cropPledgeUuid: string,
  payload?: CommonSetCropPledgeCreditorDto,
): Promise<void> => {
  const { data } = await httpClient.patch(
    `${baseCropPledgePath}/${cropPledgeUuid}/creditor-information/set-creditor`,
    payload,
  );

  return data;
};
